import React from "react";
import { IoTrophy } from "react-icons/io5";
import { Ticket } from "../../../../../models/Ticket";
import EAModal from "../../../../shared/Modal/EAModal";
import DetailsGrid from "./DetailsGrid";

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  pass: Ticket;
}

const DEMO_USED = 3;

const courseData = [
  { key: "Instruktor", value: "Anna Nowak" },
  { key: "Data pierwszych zajęć", value: "05.05.2026" },
  { key: "Uczestnik", value: "Marek Kowalski" },
  { key: "Poziom trudności", value: "Podstawowy" },
  { key: "Tor", value: "Tor 2" },
];

const rewards = [
  { label: "Pierwsza lekcja", description: "za 1. zajęcia", milestone: 1 },
  { label: "Połowa kursu", description: "za 5. zajęcia", milestone: 5 },
  { label: "Ukończenie kursu", description: "za 10. zajęcia", milestone: 10 },
];

const SwimmingCourseModal: React.FC<IProps> = ({ isOpen, onClose, pass }) => {
  return (
    <EAModal
      isOpen={isOpen}
      onClose={onClose}
      title="Informacje o kursie"
      hideAcceptButton={true}
      cancelButtonLabel="Zamknij"
      desktopWidth="600px"
    >
      <div className="swimming-course-modal">

        {/* ─── Informacje o kursie ──────────────────────────────────────────── */}
        <div className="swimming-course-modal__section">
          <DetailsGrid detailsData={courseData} />
        </div>

        {/* ─── Postęp zajęć ─────────────────────────────────────────────────── */}
        {/* <div className="swimming-course-modal__section">
          <h5>Postęp zajęć</h5>
          <div className="course-milestones">
            {Array.from({ length: DEMO_TOTAL }, (_, i) => {
              const num = i + 1;
              const isDone = i < DEMO_USED;
              const isLast = num === DEMO_TOTAL;
              return (
                <div key={num} className="course-milestone-wrapper">
                  <div className={`course-milestone ${isDone ? "course-milestone--done" : "course-milestone--pending"}`}>
                    {num}
                  </div>
                  {isLast && (
                    <span className="course-milestone__label body-text-small text-color-light-gray">
                      Finał
                    </span>
                  )}
                </div>
              );
            })}
          </div>
        </div> */}

        {/* ─── Nagrody za udział ────────────────────────────────────────────── */}
        <div className="swimming-course-modal__section">
          <h5>Nagrody za udział w kursie</h5>
          <p className="body-text-small text-color-light-gray">
            Zdobywaj nagrody za regularny udział w zajęciach.
          </p>
          <div className="course-rewards">
            {rewards.map((reward) => {
              const unlocked = DEMO_USED >= reward.milestone;
              return (
                <div
                  key={reward.milestone}
                  className={`course-reward ${unlocked ? "course-reward--unlocked" : "course-reward--locked"}`}
                >
                  <IoTrophy className="course-reward__icon" />
                  <span className="body-text-small text-bold">{reward.label}</span>
                  <span className="caption text-color-light-gray">{reward.description}</span>
                </div>
              );
            })}
          </div>
        </div>

      </div>


    </EAModal>
  );
};

export default SwimmingCourseModal;
